import React, { useState, useEffect, useRef } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Label,
    CardImg
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"

import Axios from "../../../helpers/axios_helper"
import * as CHelper from "../../../helpers/custom_helper"
import { useHistory } from "react-router-dom"
import { toast } from 'react-toastify/dist/react-toastify';
import mediaImage from "../../../assets/images/media.jpeg";
const moment = require('moment');

const Model = (props) => {
    const history = useHistory()
    const [menuHeads, setMenuHeads] = useState([]);
    const [menuHeadId, setMenuHeadId] = useState()
    const [updateData, setUpdateData] = useState(false)
    const [imageSrc, setImageSrc] = useState(mediaImage);
    const [files, setFiles] = useState([]);

    const handleSubmit = async (event, errors, values) => {
        
        window.sLoader();
        if(errors.length>0){
            errors.forEach(element => {
                toast.error(`${CHelper.separateCamelCaseString(element)} is required !`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                });
            });
        }
        else if (props.id && props.id>0 && imageSrc==mediaImage){
            toast.error(`Feature image is required !`, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
            });
        }
        // else if (!props.id && files.length==0){
        //     toast.error(`Feature image is required !`, {
        //         position: toast.POSITION.TOP_RIGHT,
        //         autoClose: 3000,
        //     });
        // }
        else{
            if(props.id && props.id==updateData.id){
                const jsonData = {
                    menuHeadId: menuHeadId,
                    eventTypeName: values.eventTypeName,
                    eventTypeDescription: values.eventTypeDescription
                }
                
                await Axios.patch(`/eventType/id/${updateData.id}`, jsonData)
                .then(async (response) => {
                    if (response.data.status === 200) {
                        
                        const formData = new FormData();
                        for (let i = 0; i < files.length; i++) {
                            formData.append('file', files[i]);
                        }
                        if(files.length>0){
                            const removeFilesName = [];
                            for (let i = 0; i < updateData.files.length; i++) {
                                removeFilesName.push(updateData.files[i].name);
                            }
                            formData.append(`remove`, JSON.stringify(removeFilesName));
                        }
                        await Axios.post(`/file/upload/eventType&${updateData.id}`, formData, {
                        })
                        .then(response => { 
                            toast.success('Course Type updated successfully!', {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                            props.handleCallback(response.data)
                        })
                        .catch(function (error) {
                            toast.error("File Uploaded Failed !", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                        });
                    } else {
                        toast.error(response.data.message, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                        });
                    }
                })
                .catch((e) => {
                    toast.error(e, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000,
                    });
                })
            }
            else{
                const jsonData = {
                    menuHeadId: menuHeadId,
                    eventTypeName: values.eventTypeName,
                    eventTypeDescription: values.eventTypeDescription
                }
                
                await Axios.post("/eventType", jsonData)
                .then(async (response) => {
                    if (response.data.status === 201) {
                        
                        const formData = new FormData();
                        for (let i = 0; i < files.length; i++) {
                            formData.append('file', files[i]);
                        }
    
                        await Axios.post(`/file/upload/eventType&${response.data.id}`, formData, {
                        })
                        .then(res => { 
                            toast.success('Event Type created successfully!', {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                            setTimeout(() => {
                                history.push("/event-type-list");
                            }, 1000);
                        })
                        .catch(function (error) {
                            toast.error("File Uploaded Failed !", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                        });
                    } else {
                        toast.error(response.data.message, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                        });
                    }
                })
                .catch((e) => {
                    toast.error(e, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000,
                    });
                })
            }
            
        }

        window.hLoader();
    }

    const fileChangeEvent = (event) => {
        let documentFile = event.target.files[0];
        setFiles([...event.target.files]);
        CHelper.convertToWebP(documentFile, setImageSrc);
    }


    useEffect(async () => {
        window.sLoader();
        if (props.id && props.id > 0) {
            await Axios.get(`/eventType/id/${props.id}`)
            .then((response) => { 
            if(response.data.status===200){
                setMenuHeadId(response.data.data.menuHeadId);
                setUpdateData(response.data.data);
                if(response.data.data.files.length>0){
                    setImageSrc(CHelper.getsimplifyLink(response.data.data.files[0].link))
                }
            }
            })
        }
        await Axios.get("/menuHead/dropdown")
            .then((response) => {
                if (response.data.status === 200) {
                    setMenuHeads(response.data.data);
                }
                else {
                    setMenuHeads([])
                }
            });
        window.hLoader();
    }, [props.id]);


    return (
        <Row>
            {(!props.id || props.id === 0 || (props.id > 0 && updateData)) &&
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <AvForm className="needs-validation" onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="6">
                                        <Col md="12">
                                            <div className="mb-3">
                                                <Label>Name</Label>
                                                <AvField
                                                    name="eventTypeName"
                                                    placeholder="Type name"
                                                    defaultValue={updateData.eventTypeName}
                                                    // onChange={(e)=>{amountChangeEvent(e.target.value);}}
                                                    type="text"
                                                    errorMessage={`Please provide ${CHelper.separateCamelCaseString('eventTypeName')}`}
                                                    validate={{ required: { value: true } }}
                                                    className="form-control"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="12">
                                            <div className="mb-3">
                                                <Label>Menu Head</Label>
                                                <Select
                                                    name="menuHeadId"
                                                    options={menuHeads}
                                                    value={menuHeads ? menuHeads.filter(x => x.value == menuHeadId)[0] : null}
                                                    onChange={(e) => { setMenuHeadId(e.value); }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="12">
                                            <div className="mb-3">
                                                <Label htmlFor="validationCustom05">Description</Label>
                                                <AvField
                                                    name="eventTypeDescription"
                                                    defaultValue={updateData.eventTypeDescription}
                                                    placeholder="Description"
                                                    type="textarea"
                                                    className="form-control"
                                                    errorMessage={`Please provide ${CHelper.separateCamelCaseString('eventTypeDescription')}`}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </div>
                                        </Col>


                                    </Col>
                                    <Col md="6">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3" style={{ textAlign: "center" }}>
                                                    {/* <CardTitle className="h4">Feature Image</CardTitle> */}
                                                    <CardImg className="img-fluid" src={imageSrc} alt="" style={{ maxHeight: "300px", width: "auto" }} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3 justify-content-center d-flex flex-row">
                                                    <label type="button" className="btn btn btn-info col-md-5" style={{ textAlign: "center" }}><i className="fa fa-upload"></i> Change Image<input hidden onChange={fileChangeEvent} accept="image/png, image/gif, image/jpeg, image/jpg" type="file" multiple="multiple" /></label>
                                                    <label hidden style={{ textAlign: "center" }} type="button" onClick={() => CHelper.downloadImage(imageSrc)} className="btn btn btn-primary col-md-5"><i className="fa fa-download"></i> Download Image</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <Button color="primary" type="submit">
                                        Submit
                                    </Button>
                                </Col>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Col>
            }
        </Row>
    )
}

export default Model
